import { LockedStateEnum, ModuleStateEnum } from "./module-state.enum";

export const isLockedState = (state: ModuleStateEnum): boolean => {
  return [...(Object.values(LockedStateEnum) as string[])].includes(state);
};
